<template>
	<div>
		<section
			id="cardSliderToggle"
			class="py-10 xl:pt-[120px] xl:pb-[60px] overflow-hidden will-change"
			:class="computedClass"
			:data-scroll-section="inner == 'false'"
		>
			<div class="px-content gap-x-[40px] mb-16 flex justify-center">
				<p
					class="title-m text-xl"
					v-for="(blockData, index) in blockData.sliders"
					:key="index"
					@click="toggleSliders(index)"
					:class="{ 'is-active': blockData.isOpen }"
				>
					{{ blockData.title }}
				</p>
			</div>

			<div
				v-for="(blockData, index) in blockData.sliders"
				:key="index"
				class="overflow-hidden will-change"
			>
				<div class="wrapper-m" :class="{ 'is-visible': blockData.isOpen }">
					<div class="px-content mb-16 w-fit">
						<h2 class="text-4xl xl:text-heading mb-8" v-show="blockData.title">
							{{ blockData.title }}
						</h2>
						<template v-if="blockData.type === 'Properties'">
							<!-- controls -->
							<div class="flex items-center justify-between relative px-4 mb-8">
								<div
									class="pagination-event flex-auto bg-mid-grey h-[1px]"
								></div>

								<div
									class="hidden controls xl:flex items-center w-[35vw] absolute left-[100%]"
								>
									<div class="control-left mr-7">
										<svg
											width="10"
											height="18"
											viewBox="0 0 10 18"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M9 16.5L1.5 9L9 1.5"
												stroke="black"
												stroke-linecap="square"
											/>
										</svg>
									</div>

									<div class="control-right ml-7">
										<svg
											width="10"
											height="18"
											viewBox="0 0 10 18"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M1 1.5L8.5 9L1 16.5"
												stroke="black"
												stroke-linecap="square"
											/>
										</svg>
									</div>
								</div>

								<!-- <a v-show="blockData.cta" :href="blockData.cta.url"
                                    class="uppercase text-xs flex items-center tracking-little">{{ blockData.cta.title }}
                                    <svg class="ml-6" width="60" height="60" viewBox="0 0 60 60" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="30" cy="30" r="29.5" stroke="#808F98" />
                                        <path d="M20 30L39 30" stroke="#405664" stroke-width="1.2" stroke-linecap="square"
                                            stroke-linejoin="round" />
                                        <path d="M36 26L40 30L36 34" stroke="#405664" stroke-width="1.2"
                                            stroke-linecap="square" />
                                    </svg>
                                </a> -->
							</div>
							<!-- ./controls -->
						</template>
						<div
							class="block-text xl:max-w-[40vw]"
							v-show="blockData.text"
							v-html="blockData.text"
						></div>
					</div>

					<!-- EVENTS SLIDER -->
					<template v-if="blockData.type === 'Events'">
						<div class="event-slider">
							<div
								class="swiper-container"
								ref="sliderEvents"
								v-observe-visibility="{ callback: moveSliderOnce, once: true }"
							>
								<div class="swiper-wrapper pl-content">
									<div
										v-for="(slide, index) in blockData.slides"
										:key="index"
										class="swiper-slide self-stretch flex flex-col cursor-pointer relative"
										@click="goToLocation(slide)"
									>
										<div>
											<img
												class="rounded-t object-cover w-full"
												v-show="slide.data.fields.image"
												:src="slide.data.fields.image.sizes.eventslide"
												:alt="slide.data.fields.image.alt"
											/>
										</div>

										<span
											class="date bg-white flex flex-col items-center justify-center rounded-sm px-[15px] py-[10px] absolute top-2 left-2"
										>
											<span
												class="text-4xl leading-tight font-canela tracking-[2px]"
												v-show="slide.data.fields.start"
												>{{ formatDateDay(slide.data.fields.start) }}</span
											>
											<span
												class="uppercase tracking-little"
												v-show="slide.data.fields.start"
												>{{ formatDateMonth(slide.data.fields.start) }}</span
											>
										</span>

										<div
											class="note flex flex-col flex-shrink bg-navy-blue-01 rounded-b text-white py-5 px-6 h-full transition-all"
										>
											<div
												class="text-lg leading-tight font-medium mb-6"
												v-show="slide.title.rendered"
												v-html="slide.title.rendered"
											></div>
											<div class="time-wrap mt-auto flex items-center">
												<svg
													width="24"
													height="24"
													viewBox="0 0 24 24"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														d="M12 22C16.9706 22 21 17.9706 21 13C21 8.02944 16.9706 4 12 4C7.02944 4 3 8.02944 3 13C3 17.9706 7.02944 22 12 22Z"
														stroke="#B7E4F8"
														stroke-width="1.2"
														stroke-linecap="square"
													/>
													<path
														d="M12 8V13L15 16"
														stroke="#B7E4F8"
														stroke-width="1.2"
														stroke-linecap="square"
													/>
													<path
														d="M2 5L5 2M19 2L22 5L19 2Z"
														stroke="#B7E4F8"
														stroke-width="1.2"
														stroke-linecap="square"
													/>
												</svg>

												<span
													class="ml-2 text-xs tracking-little font-bold"
													v-show="slide.data.fields.start"
													>{{ formatTime(slide.data.fields.start) }}</span
												>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>

						<!-- controls -->
						<div class="px-content flex items-center xl:justify-between mt-14">
							<div class="controls hidden xl:flex items-center w-[35vw]">
								<div class="control-left mr-7">
									<svg
										width="10"
										height="18"
										viewBox="0 0 10 18"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M9 16.5L1.5 9L9 1.5"
											stroke="black"
											stroke-linecap="square"
										/>
									</svg>
								</div>

								<div
									class="pagination-event flex-auto bg-mid-grey h-[1px]"
								></div>

								<div class="control-right ml-7">
									<svg
										width="10"
										height="18"
										viewBox="0 0 10 18"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M1 1.5L8.5 9L1 16.5"
											stroke="black"
											stroke-linecap="square"
										/>
									</svg>
								</div>
							</div>

							<a
								v-show="blockData.cta"
								:href="blockData.cta.url"
								class="uppercase text-xs flex items-center tracking-little"
								>{{ blockData.cta.title }}
								<svg
									class="ml-6 w-10 xl:w-[60px] h-10 xl:h-[60px]"
									width="60"
									height="60"
									viewBox="0 0 60 60"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<circle cx="30" cy="30" r="29.5" stroke="#808F98" />
									<path
										d="M20 30L39 30"
										stroke="#405664"
										stroke-width="1.2"
										stroke-linecap="square"
										stroke-linejoin="round"
									/>
									<path
										d="M36 26L40 30L36 34"
										stroke="#405664"
										stroke-width="1.2"
										stroke-linecap="square"
									/>
								</svg>
							</a>
						</div>
						<!-- ./controls -->
					</template>

					<!-- PROPERTIES SLIDER -->
					<template v-if="blockData.type === 'Properties'">
						<div class="properti-slider">
							<!-- Slider 1 -->
							<div
								ref="sliderProperties"
								class="swiper-container"
								:class="computedClass"
							>
								<div class="swiper-wrapper pl-content">
									<div
										v-for="(slide, index) in blockData.slides"
										:key="index"
										class="swiper-slide self-stretch relative flex flex-col"
										:class="{ 'cursor-pointer': !blockData.slidecta }"
										@click="handleSlideClick(blockData, slide)"
									>
										<div class="mb-2">
											<img
												class="object-cover w-full"
												v-show="slide.data.fields.image"
												:src="slide.data.fields.image.sizes.customslide"
												:alt="slide.data.fields.image.alt"
											/>
										</div>

										<div
											class="m-note note h-full flex flex-wrap flex-shrink py-4"
										>
											<div>
												<div
													class="text-sm mb-2 leading-tight"
													v-show="slide.neighbourhood"
													v-html="getNeigbourhoodName(slide.neighbourhood[0])"
												></div>
												<h4
													class="text-2xl leading-tight font-normal xl:font-light"
													v-show="slide.title.rendered"
													v-html="slide.title.rendered"
												></h4>
											</div>
											<div class="flex items-center mb-18">
												<div class="time-wrap mt-auto flex items-center mr-10">
													<svg
														width="24"
														height="24"
														viewBox="0 0 24 24"
														fill="none"
														xmlns="http://www.w3.org/2000/svg"
													>
														<path
															fill-rule="evenodd"
															clip-rule="evenodd"
															d="M3.49287 2.84016C3.89277 2.55134 4.39614 2.39844 5.00041 2.39844H19.0004C19.6047 2.39844 20.1081 2.55134 20.508 2.84016C20.9041 3.12627 21.152 3.51196 21.3075 3.90063C21.6008 4.63403 21.6006 5.4804 21.6004 5.966L21.6004 5.99851V12.4109C21.9433 12.6881 22.1645 13.0431 22.3075 13.4006C22.6008 14.134 22.6006 14.9804 22.6004 15.466L22.6004 15.4985V18.4986C22.6004 18.8299 22.3318 19.0986 22.0004 19.0986H21.6004V20.9985C21.6004 21.3299 21.3318 21.5985 21.0004 21.5985C20.669 21.5985 20.4004 21.3299 20.4004 20.9985V19.0986H3.6004V20.9985C3.6004 21.3299 3.33177 21.5985 3.0004 21.5985C2.66902 21.5985 2.4004 21.3299 2.4004 20.9985V19.0986H2.00041C1.66903 19.0986 1.40041 18.8299 1.40041 18.4986V15.4985L1.4004 15.466C1.40024 14.9804 1.39997 14.134 1.69332 13.4006C1.83632 13.0431 2.05756 12.6881 2.40041 12.4108V5.99851L2.4004 5.966C2.40025 5.4804 2.39997 4.63402 2.69332 3.90063C2.84879 3.51196 3.09673 3.12627 3.49287 2.84016ZM20.4004 5.99851V11.9224C20.2724 11.9065 20.1391 11.8984 20.0004 11.8984H18.5V9.00003C18.5 8.17159 17.8284 7.5 17 7.5H14C13.1716 7.5 12.5 8.17159 12.5 9.00003V11.8984H11.5V9.00003C11.5 8.17159 10.8284 7.5 10 7.5H7C6.17157 7.5 5.5 8.17159 5.5 9.00003V11.8984H4.00041C3.86175 11.8984 3.72841 11.9065 3.60041 11.9224V5.99851C3.60041 5.47811 3.60751 4.84629 3.8075 4.34631C3.90203 4.10997 4.02909 3.93315 4.19545 3.813C4.35805 3.69556 4.60468 3.59846 5.00041 3.59846H19.0004C19.3961 3.59846 19.6428 3.69556 19.8054 3.813C19.9717 3.93315 20.0988 4.10997 20.1933 4.34631C20.3933 4.84629 20.4004 5.47811 20.4004 5.99851ZM13.5 11.8984V9.00003C13.5 8.72388 13.7239 8.50002 14 8.50002H17C17.2761 8.50002 17.5 8.72388 17.5 9.00003V11.8984H13.5ZM10.5 9.00003V11.8984H6.5V9.00003C6.5 8.72388 6.72386 8.50002 7 8.50002H10C10.2761 8.50002 10.5 8.72388 10.5 9.00003ZM2.80749 13.8463C2.6075 14.3463 2.60041 14.9781 2.60041 15.4985V17.8986H21.4004V15.4985C21.4004 14.9781 21.3933 14.3463 21.1933 13.8463C21.0988 13.61 20.9717 13.4331 20.8054 13.313C20.6428 13.1956 20.3961 13.0985 20.0004 13.0985H4.00041C3.60467 13.0985 3.35805 13.1956 3.19545 13.313C3.02909 13.4331 2.90203 13.61 2.80749 13.8463Z"
															fill="#405664"
														/>
													</svg>
													<span
														class="text-sm ml-3"
														v-show="slide.data.fields.number_of_bedrooms"
														>{{
															getBedroomsLabelForSingleProperty(
																slide.data.fields.number_of_bedrooms
															)
														}}</span
													>
												</div>
												<div class="time-wrap mt-auto flex items-center">
													<svg
														width="24"
														height="24"
														viewBox="0 0 24 24"
														fill="none"
														xmlns="http://www.w3.org/2000/svg"
													>
														<path
															fill-rule="evenodd"
															clip-rule="evenodd"
															d="M12.0454 3.00203C12.0304 3.00069 12.0151 3 11.9997 3C11.9842 3 11.969 3.00069 11.9539 3.00203L3.50943 3.00203C3.22808 3.00203 3 3.23013 3 3.51152V20.4944C3 20.7758 3.22808 21.0039 3.50943 21.0039H11.9755C11.9835 21.0043 11.9916 21.0045 11.9997 21.0045C12.1877 21.0045 12.352 20.9026 12.4402 20.751C12.4842 20.6756 12.5094 20.588 12.5094 20.4944C12.5094 20.4882 12.5093 20.482 12.5091 20.4759L12.5091 15.4001C12.5091 15.1187 12.281 14.8906 11.9997 14.8906C11.7183 14.8906 11.4902 15.1187 11.4902 15.4001V19.9849H4.01887L4.01887 4.021L11.4902 4.021V11.4922H6.90592C6.62457 11.4922 6.39649 11.7203 6.39649 12.0017C6.39649 12.2831 6.62457 12.5112 6.90592 12.5112H17.0946C17.376 12.5112 17.604 12.2831 17.604 12.0017C17.604 11.7203 17.376 11.4922 17.0946 11.4922H12.5091V4.021L19.9811 4.021L19.9811 19.9849H15.8208C15.5394 19.9849 15.3113 20.213 15.3113 20.4944C15.3113 20.7758 15.5394 21.0039 15.8208 21.0039H20.4906C20.7719 21.0039 21 20.7758 21 20.4944V3.51152C21 3.23013 20.7719 3.00203 20.4906 3.00203L12.0454 3.00203Z"
															fill="#405664"
														/>
													</svg>
													<span
														class="text-sm ml-3"
														v-show="slide.data.fields.size"
														>{{ slide.data.fields.size }} m²</span
													>
												</div>
											</div>
											<div
												v-if="blockData.slidecta"
												class="flex flex-wrap items-stretch w-full gap-x-[44px]"
											>
												<div class="flex flex-col w-full">
													<div
														@click="
															openModal(
																blockData,
																slide,
																slide.data.fields.modalfeatures,
																slide.data.fields.modalslider,
																slide.data.fields.modaltext,
																slide.data.fields.modallink
															)
														"
														class="btn-m btn basis-auto uppercase max-w-[100%] cursor-pointer"
													>
														{{ blockData.modalbuttonlabel }}
														<svg
															class="ml-6"
															width="24"
															height="24"
															viewBox="0 0 24 24"
															fill="none"
															xmlns="http://www.w3.org/2000/svg"
														>
															<path
																d="M2 12L21 12"
																stroke="#001E31"
																stroke-width="1.2"
																stroke-linecap="square"
																stroke-linejoin="round"
															/>
															<path
																d="M18 8L22 12L18 16"
																stroke="#001E31"
																stroke-width="1.2"
																stroke-linecap="square"
															/>
														</svg>
													</div>

													<a
														v-if="slide.data.fields.modallink"
														:href="slide.data.fields.modallink['url']"
														class="btn-m btn btn-blue basis-auto uppercase max-w-[100%]"
														>{{ slide.data.fields.modallink["title"] }}
														<svg
															class="ml-6"
															width="24"
															height="24"
															viewBox="0 0 24 24"
															fill="none"
															xmlns="http://www.w3.org/2000/svg"
														>
															<path
																d="M2 12L21 12"
																stroke="white"
																stroke-width="1.2"
																stroke-linecap="square"
																stroke-linejoin="round"
															/>
															<path
																d="M18 8L22 12L18 16"
																stroke="white"
																stroke-width="1.2"
																stroke-linecap="square"
															/>
														</svg>
													</a>

													<!-- Second Button (Below Learn More) -->

													<a
														v-if="blockData.cta && !slide.data.fields.modallink"
														:href="blockData.cta.url"
														class="btn btn-blue justify-center text-center basis-auto uppercase max-w-[100%] cursor-pointer"
													>
														{{ blockData.cta.title }}
														<svg
															class="ml-6"
															width="24"
															height="24"
															viewBox="0 0 24 24"
															fill="none"
															xmlns="http://www.w3.org/2000/svg"
														>
															<path
																d="M2 12L21 12"
																stroke="white"
																stroke-width="1.2"
																stroke-linecap="square"
																stroke-linejoin="round"
															/>
															<path
																d="M18 8L22 12L18 16"
																stroke="white"
																stroke-width="1.2"
																stroke-linecap="square"
															/>
														</svg>
													</a>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</template>

					<!-- PORTFOLIO SLIDER -->
					<template v-if="blockData.type === 'Portfolios'">
						<div class="properti-slider">
							<div
								class="swiper-container"
								ref="sliderPortfolios"
								v-observe-visibility="{ callback: moveSliderOnce, once: true }"
							>
								<div class="swiper-wrapper pl-content">
									<div
										v-for="(slide, index) in blockData.slides"
										:key="index"
										class="swiper-slide self-stretch relative flex flex-col cursor-pointer"
										@click.stop.prevent="showPlaceSlide(slide)"
									>
										<!-- OVO PRAVI ERROR u CONSOLI JER SE MENJA BLCOKDATA PRi DOVLACENJU NOVIH -->
										<div>
											<img
												class="object-cover w-full"
												v-show="slide.image"
												:src="slide.image.sizes.customslide"
												:alt="slide.image.alt"
											/>
										</div>

										<div class="note h-full flex items-center flex-shrink py-4">
											<div>
												<div
													class="text-sm mb-2 leading-tight"
													v-show="slide.location"
													v-html="slide.location"
												></div>
												<h4
													class="text-2xl leading-tight"
													v-show="slide.title"
													v-html="slide.title"
												></h4>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>

						<!-- controls -->
						<div
							class="hidden xl:flex items-center justify-between mt-14 px-content"
						>
							<div class="controls flex items-center w-[35vw]">
								<div class="control-left mr-7">
									<svg
										width="10"
										height="18"
										viewBox="0 0 10 18"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M9 16.5L1.5 9L9 1.5"
											stroke="black"
											stroke-linecap="square"
										/>
									</svg>
								</div>

								<div
									class="pagination-event flex-auto bg-mid-grey h-[1px]"
								></div>

								<div class="control-right ml-7">
									<svg
										width="10"
										height="18"
										viewBox="0 0 10 18"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M1 1.5L8.5 9L1 16.5"
											stroke="black"
											stroke-linecap="square"
										/>
									</svg>
								</div>
							</div>

							<a
								v-show="blockData.cta"
								:href="blockData.cta.url"
								class="uppercase text-xs flex items-center tracking-little"
								>{{ blockData.cta.title }}
								<svg
									class="ml-6"
									width="60"
									height="60"
									viewBox="0 0 60 60"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<circle cx="30" cy="30" r="29.5" stroke="#808F98" />
									<path
										d="M20 30L39 30"
										stroke="#405664"
										stroke-width="1.2"
										stroke-linecap="square"
										stroke-linejoin="round"
									/>
									<path
										d="M36 26L40 30L36 34"
										stroke="#405664"
										stroke-width="1.2"
										stroke-linecap="square"
									/>
								</svg>
							</a>
						</div>
						<!-- ./controls -->
						<div
							:class="{
								'xyz-in': showSlide,
								'xyz-out': !showSlide,
								' z-[40]': !showSlide,
								'z-[51]': showSlide,
							}"
							class="card-toponyms--slide fixed right-0 top-0 bottom-0 z-[51] flex flex-col bg-white shadow-md w-full sm:w-[504px] h-full overflow-y-auto invisible"
							xyz="fade right-100% duration-4"
							ref="slideCard"
							v-on-clickaway="clickAwaySlide"
						>
							<button
								type="button"
								@click="hidePlaceSlide()"
								class="grid place-items-center bg-mid-grey rounded-full cursor-pointer hover:opacity-70 w-10 h-10 absolute right-6 top-6"
							>
								<svg
									xmlns="http://www.w3.org/2000/svg"
									class="h-6 w-6"
									fill="none"
									viewBox="0 0 24 24"
									stroke="white"
								>
									<path
										stroke-linecap="round"
										stroke-linejoin="round"
										stroke-width="1"
										d="M6 18L18 6M6 6l12 12"
									/>
								</svg>
							</button>
							<div class="pb-10 h-full" v-if="activePlace">
								<div class="overflow-hidden h-[34vh]">
									<img
										class="object-cover w-full"
										:src="activePlace.image.sizes.customslide"
										:alt="activePlace.image.alt"
									/>
								</div>

								<div class="p-8">
									<div
										class="text-xs tracking-little text-navy-blue-03 mb-3"
										v-html="activePlace.location"
									></div>
									<h4
										class="text-2xl tracking-[1px] mb-5"
										v-html="activePlace.title"
									></h4>
									<div
										class="text-sm text-dark-grey leading-[1.42]"
										v-html="activePlace.text"
									></div>
								</div>
							</div>
						</div>
					</template>

					<!-- TESTIMONIAL SLIDER -->
					<template v-if="blockData.type === 'Testimonials'">
						<div class="testimonial-slider">
							<div
								class="swiper-container"
								ref="sliderTestimonials"
								v-observe-visibility="{ callback: moveSliderOnce, once: true }"
							>
								<div class="swiper-wrapper pl-content">
									<div
										v-for="(slide, index) in blockData.slides"
										:key="index"
										class="swiper-slide flex flex-col items-center justify-center bg-white py-10 px-11"
									>
										<img
											class="border-[3px] border-light-blue-01 rounded-full mb-9 mt-[14px]"
											v-show="slide.image"
											:src="slide.image.sizes.thumbnail"
											:alt="slide.image.alt"
										/>

										<div
											class="note h-full flex flex-col items-center flex-shrink py-4"
										>
											<div
												class="text-xl text-navy-blue-02 font-canela font-light leading-[1.4] text-center tracking-[1px]"
												v-show="slide.text"
												v-html="slide.text"
											></div>
											<div
												class="bg-light-blue-01 w-[72px] h-[2px] mt-8 mb-14"
											></div>
											<h4
												class="leading-tight text-center font-ginger"
												v-show="slide.title"
												v-html="slide.title"
											></h4>
										</div>
									</div>
								</div>
							</div>
						</div>

						<!-- controls -->
						<div
							class="hidden xl:flex items-center justify-between mt-14 px-content"
						>
							<div class="controls flex items-center w-[35vw]">
								<div class="control-left mr-7">
									<svg
										width="10"
										height="18"
										viewBox="0 0 10 18"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M9 16.5L1.5 9L9 1.5"
											stroke="black"
											stroke-linecap="square"
										/>
									</svg>
								</div>

								<div
									class="pagination-event flex-auto bg-mid-grey h-[1px]"
								></div>

								<div class="control-right ml-7">
									<svg
										width="10"
										height="18"
										viewBox="0 0 10 18"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M1 1.5L8.5 9L1 16.5"
											stroke="black"
											stroke-linecap="square"
										/>
									</svg>
								</div>
							</div>

							<a
								v-show="blockData.cta"
								:href="blockData.cta.url"
								class="uppercase text-xs flex items-center tracking-little"
								>{{ blockData.cta.title }}
								<svg
									class="ml-6"
									width="60"
									height="60"
									viewBox="0 0 60 60"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<circle cx="30" cy="30" r="29.5" stroke="#808F98" />
									<path
										d="M20 30L39 30"
										stroke="#405664"
										stroke-width="1.2"
										stroke-linecap="square"
										stroke-linejoin="round"
									/>
									<path
										d="M36 26L40 30L36 34"
										stroke="#405664"
										stroke-width="1.2"
										stroke-linecap="square"
									/>
								</svg>
							</a>
						</div>
						<!-- ./controls -->
					</template>

					<!-- PARTNERS SLIDER -->
					<template v-if="blockData.type === 'Partners'">
						<div class="event-slider">
							<div
								class="swiper-container"
								ref="sliderPartners"
								v-observe-visibility="{ callback: moveSliderOnce, once: true }"
							>
								<div class="swiper-wrapper pl-content">
									<div
										v-for="(slide, index) in blockData.slides"
										:key="index"
										class="swiper-slide self-stretch relative flex flex-col justify-center rounded bg-white"
										@click="goToLocation(slide)"
									>
										<div class="flex items-center justify-center p-10">
											<img
												class=""
												v-show="slide.data.fields.image"
												:src="slide.data.fields.image.sizes.eventslide"
												:alt="slide.data.fields.image.alt"
											/>
										</div>
									</div>
								</div>
							</div>
						</div>

						<!-- controls -->
						<div class="px-content flex items-center justify-between mt-14">
							<div class="controls flex items-center w-[35vw]">
								<div class="control-left mr-7">
									<svg
										width="10"
										height="18"
										viewBox="0 0 10 18"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M9 16.5L1.5 9L9 1.5"
											stroke="black"
											stroke-linecap="square"
										/>
									</svg>
								</div>

								<div
									class="pagination-event flex-auto bg-mid-grey h-[1px]"
								></div>

								<div class="control-right ml-7">
									<svg
										width="10"
										height="18"
										viewBox="0 0 10 18"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M1 1.5L8.5 9L1 16.5"
											stroke="black"
											stroke-linecap="square"
										/>
									</svg>
								</div>
							</div>

							<a
								v-show="blockData.cta"
								:href="blockData.cta.url"
								class="uppercase text-xs flex items-center tracking-little"
								>{{ blockData.cta.title }}
								<svg
									class="ml-6"
									width="60"
									height="60"
									viewBox="0 0 60 60"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<circle cx="30" cy="30" r="29.5" stroke="#808F98" />
									<path
										d="M20 30L39 30"
										stroke="#405664"
										stroke-width="1.2"
										stroke-linecap="square"
										stroke-linejoin="round"
									/>
									<path
										d="M36 26L40 30L36 34"
										stroke="#405664"
										stroke-width="1.2"
										stroke-linecap="square"
									/>
								</svg>
							</a>
						</div>
						<!-- ./controls -->
					</template>

					<!-- PRESS CLIPPING SLIDER -->
					<template v-if="blockData.type === 'Press Clippings'">
						<div class="custom-slider">
							<div
								class="swiper-container"
								ref="sliderPressCliping"
								v-observe-visibility="{ callback: moveSliderOnce, once: true }"
							>
								<div class="swiper-wrapper pl-content">
									<div
										v-for="(slide, index) in blockData.slides"
										:key="index"
										class="swiper-slide self-stretch relative flex flex-col"
									>
										<div class="mb-6">
											<img
												class="object-cover w-full h-full"
												v-show="slide.image"
												:src="slide.image.sizes.pressCliping"
												:alt="slide.image.alt"
											/>
										</div>
										<div>
											<div
												class="text-sm tracking-desk text-navy-blue-03 mb-4"
												v-show="slide.year"
											>
												{{ slide.year }}
											</div>
											<h4
												class="text-2xl mb-6"
												v-show="slide.title"
												v-html="slide.title"
											></h4>
											<a
												class="text-xs tracking-little text-navy-blue-03 uppercase"
												v-if="slide.file"
												:href="slide.file.url"
												target="_blank"
												>DOWNLOAD PDF</a
											>
										</div>
									</div>
								</div>
							</div>
						</div>

						<!-- controls -->
						<div
							class="hidden xl:flex items-center justify-between mt-14 px-content"
						>
							<div class="controls flex items-center w-[35vw]">
								<div class="control-left mr-7">
									<svg
										width="10"
										height="18"
										viewBox="0 0 10 18"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M9 16.5L1.5 9L9 1.5"
											stroke="black"
											stroke-linecap="square"
										/>
									</svg>
								</div>

								<div class="pagination flex-auto bg-mid-grey h-[1px]"></div>

								<div class="control-right ml-7">
									<svg
										width="10"
										height="18"
										viewBox="0 0 10 18"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M1 1.5L8.5 9L1 16.5"
											stroke="black"
											stroke-linecap="square"
										/>
									</svg>
								</div>
							</div>
						</div>
						<!-- ./controls -->
					</template>

					<!-- CUSTOM SLIDER -->
					<template v-if="blockData.type === 'Custom'">
						<div class="custom-slider">
							<div
								class="swiper-container"
								ref="sliderCustom"
								v-observe-visibility="{ callback: moveSliderOnce, once: true }"
							>
								<div class="swiper-wrapper pl-content">
									<div
										v-for="(slide, index) in blockData.slides"
										:key="index"
										class="swiper-slide cursor-pointer"
										@click="goToLocation(slide)"
									>
										<div
											class="relative overflow-hidden cursor-pointer after:block after:bg-black after:opacity-20 after:absolute after:w-full after:h-full after:z-[8] after:top-0 after:left-0 hover:after:opacity-50 after:transition-opacity"
										>
											<img
												class="object-cover w-full h-full"
												v-show="slide.image"
												:src="slide.image.sizes.customslide"
												:alt="slide.image.alt"
											/>
											<h4
												class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-white text-2xl text-center px-4 w-full z-10"
												v-show="slide.title"
												v-html="slide.title"
											></h4>
										</div>
									</div>
								</div>
							</div>
						</div>

						<!-- controls -->
						<div
							class="hidden xl:flex items-center justify-between mt-14 px-content"
						>
							<div class="controls flex items-center w-[35vw]">
								<div class="control-left mr-7">
									<svg
										width="10"
										height="18"
										viewBox="0 0 10 18"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M9 16.5L1.5 9L9 1.5"
											stroke="black"
											stroke-linecap="square"
										/>
									</svg>
								</div>

								<div class="pagination flex-auto bg-mid-grey h-[1px]"></div>

								<div class="control-right ml-7">
									<svg
										width="10"
										height="18"
										viewBox="0 0 10 18"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M1 1.5L8.5 9L1 16.5"
											stroke="black"
											stroke-linecap="square"
										/>
									</svg>
								</div>
							</div>
						</div>
						<!-- ./controls -->
					</template>
				</div>
			</div>
		</section>

		<transition name="fade">
			<div
				v-if="isModalOpen"
				class="modal fixed top-0 right-0 w-[100vw] h-[100vh] z-[100] overflow-auto"
				@click.self="closeModal"
			>
				<div class="modal-body py-8 px-content">
					<button @click="closeModal">
						<svg
							width="24"
							height="24"
							viewBox="0 0 24 24"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<rect width="24" height="24" fill="#001E31" />
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M5.2499 4.40137L19.5984 18.7499L18.7499 19.5984L4.40137 5.2499L5.2499 4.40137Z"
								fill="white"
							/>
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M19.5984 5.2499L5.2499 19.5984L4.40137 18.7499L18.7499 4.40137L19.5984 5.2499Z"
								fill="white"
							/>
						</svg>
					</button>

					<div class="py-5 text-center">
						<p
							class="text-sm mb-[18px] uppercase text-[#808F98]"
							v-show="selectedSlide.neighbourhood"
							v-html="getNeigbourhoodName(selectedSlide.neighbourhood[0])"
						></p>
						<h2
							class="text-4xl leading-tight font-normal xl:font-light"
							v-show="selectedSlide.title.rendered"
							v-html="selectedSlide.title.rendered"
						></h2>

						<div class="py-5">
							<p>{{ selectedText }}</p>
						</div>

						<a
							v-if="selectedLink"
							:href="selectedLink['url']"
							class="btn btn-blue basis-auto uppercase mt-15"
							>{{ selectedLink["title"] }}
							<svg
								class="ml-6"
								width="24"
								height="24"
								viewBox="0 0 24 24"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M2 12L21 12"
									stroke="white"
									stroke-width="1.2"
									stroke-linecap="square"
									stroke-linejoin="round"
								/>
								<path
									d="M18 8L22 12L18 16"
									stroke="white"
									stroke-width="1.2"
									stroke-linecap="square"
								/>
							</svg>
						</a>
						<a
							v-if="selectedBlockData && selectedBlockData.cta && !selectedLink"
							:href="selectedBlockData.cta.url"
							class="btn btn-blue basis-auto uppercase mt-15"
							>{{ selectedBlockData.cta.title }}
						</a>
					</div>

					<div class="my-[20px]">
						<div
							v-if="selectedImageSlider"
							class="swiper-container w-full"
							ref="modalSwiper"
						>
							<div class="swiper-wrapper">
								<div
									class="swiper-slide w-full"
									v-for="(image, index) in selectedImageSlider"
									:key="index"
								>
									<img
										class="object-cover modal-image"
										v-show="image.image"
										:src="image.image.url"
										:alt="image.image.alt"
									/>
								</div>
							</div>

							<div class="modal-swiper-pagination flex justify-center"></div>
						</div>

						<img
							v-else
							class="object-cover w-full modal-image"
							v-show="selectedSlide.data.fields.image"
							:src="selectedSlide.data.fields.image.sizes.large"
							:alt="selectedSlide.data.fields.image.alt"
						/>
					</div>

					<div class="flex flex-wrap items-center justify-center">
						<div
							class="flex flex-col items-center self-start mb-10 px-2 sm:px-4 w-1/2 sm:w-1/5"
							v-for="(feature, index) in selectedFeatures"
							:key="index"
						>
							<img
								class="mb-4 w-12 xl:w-16"
								v-show="feature.icon"
								:src="feature.icon.url"
								:alt="feature.icon.alt"
							/>
							<div
								class="text-center"
								v-show="feature.text"
								v-html="feature.text"
							></div>
						</div>
					</div>
				</div>
			</div>
		</transition>
	</div>
</template>

<script>
import Swiper, { Pagination } from "swiper/bundle";
import "swiper/swiper-bundle.css";
import { format, parseISO } from "date-fns";
import { mixin as clickaway } from "vue-clickaway";

export default {
	name: "CardsSliderToggle",
	mixins: [clickaway],
	data() {
		return {
			selectedImageSlider: null,
			selectedText: null,
			selectedFeatures: null,
			selectedBlockData: null,
			selectedSlide: null,
			isModalOpen: false,
			selectedSwiper: 1,
			selectedLink: null,

			scroll: false,
			/* EVENTS SLIDER */
			sliderEvents: null,
			sliderEventsOptions: {
				slidesPerView: 1,
				spaceBetween: 12,
				breakpoints: {
					320: {
						slidesPerView: 1,
						spaceBetween: 12,
						navigation: false,
					},
					600: {
						slidesPerView: 3,
						spaceBetween: 24,
						navigation: {
							prevEl: ".controls .control-left",
							nextEl: ".controls .control-right",
						},
						scrollbar: {
							el: ".pagination-event",
							hide: false,
						},
					},
					1200: {
						slidesPerView: 4,
						spaceBetween: 24,
						navigation: {
							prevEl: ".controls .control-left",
							nextEl: ".controls .control-right",
						},
						scrollbar: {
							el: ".pagination-event",
							hide: false,
						},
					},
				},
			},
			/* PROPERTIES SLIDER */
			sliderProperties: null,
			sliderPropertiesOptions: {
				speed: 800,
				slidesPerView: 1,
				spaceBetween: 12,
				breakpoints: {
					320: {
						slidesPerView: 1,
						spaceBetween: 12,
						navigation: false,
					},
					600: {
						slidesPerView: 2,
						spaceBetween: 24,
						navigation: {
							prevEl: ".controls .control-left",
							nextEl: ".controls .control-right",
						},
						scrollbar: {
							el: ".pagination-event",
							hide: false,
						},
					},
				},
			},
			// Second Properties Slider
			sliderPropertiesTwo: null,
			sliderPropertiesTwoOptions: {
				speed: 800,
				slidesPerView: 1,
				spaceBetween: 12,
				breakpoints: {
					320: {
						slidesPerView: 1,
						spaceBetween: 12,
						navigation: false,
					},
					600: {
						slidesPerView: 2,
						spaceBetween: 24,
						navigation: {
							prevEl: ".controls .control-left",
							nextEl: ".controls .control-right",
						},
						scrollbar: {
							el: ".pagination-event",
							hide: false,
						},
					},
				},
			},
			/* PORTFOLIOS SLIDER */
			sliderPortfolios: null,
			sliderPortfoliosOptions: {
				speed: 800,
				slidesPerView: 1,
				spaceBetween: 12,
				breakpoints: {
					320: {
						slidesPerView: 1,
						spaceBetween: 12,
						navigation: false,
					},
					600: {
						slidesPerView: 2,
						spaceBetween: 24,
						navigation: {
							prevEl: ".controls .control-left",
							nextEl: ".controls .control-right",
						},
						scrollbar: {
							el: ".pagination-event",
							hide: false,
						},
					},
				},
			},
			/* TESTIMONIALS SLIDER */
			sliderTestimonials: null,
			sliderTestimonialsOptions: {
				on: {
					slideChange(e) {
						e.vueInstance.$root.scroll.update();
					},
				},
				speed: 800,
				slidesPerView: 1,
				spaceBetween: 12,
				breakpoints: {
					320: {
						slidesPerView: 1,
						spaceBetween: 12,
						navigation: false,
					},
					600: {
						slidesPerView: 2,
						spaceBetween: 24,
						navigation: {
							prevEl: ".controls .control-left",
							nextEl: ".controls .control-right",
						},
						scrollbar: {
							el: ".pagination-event",
							hide: false,
						},
					},
					1200: {
						slidesPerView: 3,
						spaceBetween: 24,
						navigation: {
							prevEl: ".controls .control-left",
							nextEl: ".controls .control-right",
						},
						scrollbar: {
							el: ".pagination-event",
							hide: false,
						},
					},
				},
			},
			/* PARTNER SLIDER */
			sliderPartners: null,
			sliderPartnersOptions: {
				speed: 800,
				slidesPerView: 2,
				spaceBetween: 12,
				breakpoints: {
					320: {
						slidesPerView: 2,
						spaceBetween: 12,
						navigation: false,
					},
					600: {
						slidesPerView: 3,
						spaceBetween: 24,
						navigation: {
							prevEl: ".controls .control-left",
							nextEl: ".controls .control-right",
						},
						scrollbar: {
							el: ".pagination-event",
							hide: false,
						},
					},
					1200: {
						slidesPerView: 4,
						spaceBetween: 24,
						navigation: {
							prevEl: ".controls .control-left",
							nextEl: ".controls .control-right",
						},
						scrollbar: {
							el: ".pagination-event",
							hide: false,
						},
					},
				},
			},
			/* PRESS CLIPPING SLIDER */
			sliderPressClipping: null,
			sliderPressClippingOptions: {
				speed: 800,
				slidesPerView: 1,
				spaceBetween: 24,
				breakpoints: {
					320: {
						slidesPerView: 1,
						spaceBetween: 12,
						navigation: false,
					},
					600: {
						slidesPerView: 3,
						spaceBetween: 24,
						navigation: {
							prevEl: ".controls .control-left",
							nextEl: ".controls .control-right",
						},
						scrollbar: {
							el: ".pagination",
							hide: false,
						},
					},
					1200: {
						slidesPerView: 4,
						spaceBetween: 24,
						navigation: {
							prevEl: ".controls .control-left",
							nextEl: ".controls .control-right",
						},
						scrollbar: {
							el: ".pagination",
							hide: false,
						},
					},
				},
			},
			/* CUSTOM SLIDER */
			sliderCustom: null,
			sliderCustomOptions: {
				speed: 800,
				slidesPerView: 1,
				spaceBetween: 12,
				breakpoints: {
					320: {
						slidesPerView: 1,
						spaceBetween: 12,
						navigation: false,
					},
					600: {
						slidesPerView: 2,
						spaceBetween: 24,
						navigation: {
							prevEl: ".controls .control-left",
							nextEl: ".controls .control-right",
						},
						scrollbar: {
							el: ".pagination",
							hide: false,
						},
					},
				},
			},

			showSlider: 1, // 1 for Slider 1, 2 for Slider 2

			showSlide: false,
			activePlace: false,
		};
	},
	computed: {
		computedClass() {
			let className = "";
			if (this.blockData.background_color === "white") {
				className = ["bg-transparent"];
			}
			if (this.blockData.background_color === "light-blue") {
				className = ["bg-light-blue-03"];
			}
			if (this.blockData.background_color === "dark-blue") {
				className = ["bg-navy-blue-01"];
			}
			return className;
		},
	},

	created() {
		this.blockData.sliders = this.blockData.sliders.map((slider, index) => ({
			...slider,
			isOpen: index === 0,
		}));
	},
	mounted() {
		this.blockData.sliders.forEach((blockData, sliderIndex) => {
			if (blockData.type === "Events") {
				// Your existing Events slider logic...
			} else if (blockData.type === "Properties") {
				var url_params = {
					per_page: 18,
					neighbourhood: blockData.properties_neighbourhoods
						? blockData.properties_neighbourhoods[0] // let WP filter it
						: this.postData.post_type === "property"
						? this.postData.neighbourhood_category[0].term_id
						: null,
				};

				this.cleanParams(url_params);
				var searchParams = new URLSearchParams(url_params);

				this.$http
					.get(
						this.endpoints.rest_base_endpoint + "wp/v2/property?" + searchParams
					)
					.then((res) => {
						let slides = [];

						if (this.postData.post_type === "property") {
							slides = res.data.filter(
								(slide) => slide.id !== parseInt(this.postData.ID)
							);
						} else {
							if (!blockData.properties_neighbourhoods) {
								slides = res.data;
							} else {
								res.data.forEach((slide) => {
									if (
										blockData.properties_neighbourhoods.includes(
											slide.neighbourhood[0]
										)
									) {
										slides.push(slide);
									}
								});
							}
						}

						this.$set(blockData, "slides", slides);

						this.$nextTick(() => {
							this.$nextTick(() => {
								const refs = this.$refs.sliderProperties;
								if (!refs) return;
								const el = Array.isArray(refs) ? refs[sliderIndex] : refs;
								if (!el) return;

								if (el.swiper) el.swiper.destroy(true, true);

								this.sliderProperties = new Swiper(
									el,
									this.sliderPropertiesOptions
								);
							});
						});
					});
			}
		});
	},
	methods: {
		resolvedUrl(slideLink) {
			const selectedLink = slideLink[0]?.fields?.modallink
				? slideLink[0]?.fields?.modallink
				: slideLink[1].link;

			return selectedLink["url"];
		},

		resolvedLabel(slideLink) {
			const selectedLabel = slideLink[0]?.fields?.modallink
				? slideLink[0]?.fields?.modallink
				: slideLink[1].link;

			return selectedLabel["title"];
		},

		openModal(
			blockData,
			slide,
			slideModalFeatures,
			slideModalImageSlider,
			slideText,
			slideLink
		) {
			this.selectedImageSlider = slideModalImageSlider;
			this.selectedText = slideText;
			this.selectedFeatures = slideModalFeatures;
			this.selectedBlockData = blockData;
			this.selectedSlide = slide;
			this.isModalOpen = true;
			this.selectedLink = slideLink;

			this.$nextTick(() => {
				if (this.$refs.modalSwiper) {
					this.selectedSwiper = new Swiper(this.$refs.modalSwiper, {
						slidesPerView: 1,
						modules: [Pagination],
						pagination: {
							el: ".modal-swiper-pagination",
							clickable: true,
						},
					});
				}
			});

			if (window.locomotiveScroll) {
				window.locomotiveScroll.stop();
			}
		},

		closeModal() {
			this.selectedImageSlider = null;
			this.selectedText = null;
			this.selectedLink = null;
			this.selectedFeatures = null;
			this.selectedBlockData = null;
			this.isModalOpen = false;
			this.selectedSlide = null;
			this.selectedSwiper = null;
			this.selectedLink = null;
			this.selectedLabel = null;

			if (window.locomotiveScroll) {
				window.locomotiveScroll.start();
			}
		},

		clickAwaySlide() {
			this.showSlide = false;
		},
		goToLocation(slide) {
			window.location.href = slide.cta ? slide.cta.url : slide.link;
		},
		handleSlideClick(blockData, slide) {
			if (!blockData.slidecta) {
				this.goToLocation(slide);
			}
		},
		toggleSlider(sliderId) {
			this.showSlider = sliderId; // Toggle between Slider 1 and Slider 2
		},
		toggleSliders(activeIndex, sliderType) {
			const refName = `slider${sliderType}`;

			// Set which slider is open
			this.blockData.sliders.forEach((slider, index) => {
				this.$set(slider, "isOpen", index === activeIndex);
			});
		},
		formatDateDay(date) {
			let formated = format(parseISO(date), "dd");
			return formated;
		},
		formatDateMonth(date) {
			let formated = format(parseISO(date), "MMM");
			return formated;
		},
		formatTime(date) {
			let formated = format(parseISO(date), "HH:mm");
			return formated;
		},
		getNeigbourhoodName(id) {
			let result = this.neighbourhoodsData.filter((n) => n.term_id === id);
			return result[0].name;
		},
		getBedroomsLabelForSingleProperty(number) {
			number = parseInt(number);
			if (number === -1) {
				return this.__("Studio", "ccave");
			} else if (number >= 1) {
				return number;
			}
		},
		cleanParams(obj) {
			for (var propName in obj) {
				if (
					obj[propName] === null ||
					obj[propName] === undefined ||
					obj[propName] === "" ||
					obj[propName].length == 0
				) {
					delete obj[propName];
				}
			}
			return obj;
		},
		shuffleArray(array) {
			for (let i = array.length - 1; i > 0; i--) {
				const j = Math.floor(Math.random() * (i + 1));
				[array[i], array[j]] = [array[j], array[i]];
			}
			return array;
		},
		moveSliderOnce(isVisibe, entry) {
			if (isVisibe) {
				setTimeout(() => {
					entry.target.swiper.slideTo(0, 800, false);
				}, 500);
			}
		},
		showPlaceSlide(place) {
			if (
				this.$refs.slideCard.classList.contains("invisible") &&
				!this.showSlide
			) {
				this.activePlace = place;
				this.$refs.slideCard.style.visibility = "visible";
				this.showSlide = true;
			}

			let offsetCard;
			if (this.$root.isMobile) {
				offsetCard = -67;
			} else {
				offsetCard = -116;
			}

			this.$root.scroll.scrollTo("#cardSlider", {
				offset: offsetCard,
				duration: 800,
				disableLerp: true,
			});
		},
		hidePlaceSlide() {
			setTimeout(() => {
				this.$refs.slideCard.style.visibility = "hidden";
			}, 500);
			this.showSlide = false;
		},
	},
	watch: {
		isModalOpen(val) {
			const root = this.$root;
			if (val) {
				// Stop scroll
				if (root.scroll && typeof root.scroll.stop === "function")
					root.scroll.stop();
				document.body.style.overflow = "hidden";
			} else {
				// Start scroll
				if (root.scroll && typeof root.scroll.start === "function")
					root.scroll.start();
				document.body.style.overflow = "";
			}
		},
	},
};
</script>

<style scoped>
.m-note {
	flex-direction: column;
	gap: 10px 0;
	justify-content: flex-start !important;
}

.modal {
	background-color: #edf5fa;
}

.btn-m {
	flex: 1;
	justify-content: center;
	padding: 16px 1rem !important;
}

.modal-image {
	aspect-ratio: 992 / 520;
}

@media screen and (min-width: 1000px) {
	.m-note {
		flex-direction: row;
		justify-content: space-between !important;
	}
}

@media screen and (min-width: 1280px) {
	.modal {
		background-color: transparent;
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: #001e318f;
	}

	.modal-body {
		background-color: #edf5fa;
		max-width: 65vw;
		max-height: 90vh;
		overflow: auto;
	}
}

.btn-m svg {
	flex-shrink: 0;
}
.w-fit {
	width: fit-content;
}

.wrapper-m {
	opacity: 0;
	position: absolute;
	max-width: 100%;
	transition: opacity 0s;
}

.wrapper-m.is-visible {
	opacity: 1;
	position: static;
	transition: opacity 0.3s;
}

.title-m {
	line-height: 1.2857;
	letter-spacing: 2px;
	font-family: Canela;
	font-weight: 300;
	cursor: pointer;
	position: relative;
	padding-bottom: 5px;
}

.title-m::before {
	content: "";
	position: absolute;
	bottom: 0;
	left: 0;
	height: 1px;
	width: 85%;
	background-color: #001e31;
	transform: scaleX(0);
	transition: transform 0.3s;
}

.title-m:not(:last-child) {
	margin-right: 40px;
}

.title-m:not(:last-child)::after {
	content: "";
	position: absolute;
	right: -40px;
	bottom: 0;
	height: 100%;
	width: 1px;
	background-color: #bfbfbf;
}

.title-m.is-active,
.title-m:hover {
	color: #001e31;
}

.title-m.is-active::before,
.title-m:hover::before {
	transform: scaleX(1);
}

.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
	opacity: 0;
}

.modal-swiper-pagination {
	margin-top: 25px;
	margin-bottom: 40px;
}

:deep(.modal-swiper-pagination > .swiper-pagination-bullet-active) {
	background-color: #001e31 !important;
}
</style>
